const siteData = {
  title: 'Utopia Films - Film and photo production in Brazil, Venezuela, USA, Caribbean and Costa Rica',
};

export default siteData;
